import { useState } from 'react'
import { PrintableElement, ScrollToTop } from '../components'
import { CVNav } from '../components/CVNav'
import { useNavigate } from 'react-router-dom'

export const MyCV = () => {
  const [disableAnimation] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <ScrollToTop />
      <CVNav />

      {/* Back Button */}
      <button
        onClick={() => navigate('/')}
        className="fixed top-5 left-5 md:top-10 md:left-10 z-50 no-print group"
        aria-label="Go back to home"
      >
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-charcoal flex items-center justify-center group-hover:bg-charcoal group-hover:border-[#ff6347] transition-all duration-300">
            <span className="text-charcoal group-hover:text-custom-background transition-colors duration-300 text-base md:text-lg">←</span>
          </div>
          <span className="hidden md:inline text-sm font-[500] text-charcoal opacity-0 group-hover:opacity-100 transition-opacity duration-300">Back</span>
        </div>
      </button>

      <div className={`home h-full px-5 py-[50px] md:py-[100px] md:px-0 bg-custom-background`}>
        <PrintableElement disableAnimation={disableAnimation} />
      </div>
    </>
  )
}
